import { ProfileAdditionalDataItemList } from "../profile-data-input/profile-additional-data-item-list.js";
import { DataBaseComponent } from "./data-base-component.js";


export class DataProfilesAdditionalComponent extends DataBaseComponent {
    static webComponentName: string = "data-profiles-additional";
    protected _templateId: string = "data-profiles-additional";
    protected profileAdditionalComponent:ProfileAdditionalDataItemList|null=null;
    get value(): any {
        if (this.profileAdditionalComponent ) {
            return this.profileAdditionalComponent.value;
        }
        return super.value;
    }
     set value(newValue: any) {
        super.value = newValue;
    }
    constructor() {
        super();
    }
    addDataForTemplate(): Record<string, any> {
        return {
            readOnly:this.readOnly,
            profileAdditional: this.value
        };
    }
    protected afterRender(): void {
        super.afterRender();
        this.profileAdditionalComponent = this.querySelector<ProfileAdditionalDataItemList>('profile-additional-data-item-list');
    }

}